// extracted by mini-css-extract-plugin
module.exports = {"component":"DateSelectorTrigger_component__2fITy","indicator":"DateSelectorTrigger_indicator__1BNKi","date":"DateSelectorTrigger_date__3RLrt"};